import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((_) => ({
  tabs: {
    marginBottom: 20,
  },
  documentsBox: {
    minHeight: 80,
  },
}));
